import { styled } from "@mui/material";

export const StyledFlex = {
  ColumnContainer: styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
  })),
  Flex: styled("div")(({ theme }) => ({
    flex: 1,
  })),
  Title: styled("div")(({ theme }) => ({
    flex: 1,
    display: "flex",
    justifyContent: "center",
    marginLeft: 20,
    marginRight: 40,
  })),
};
